export const PRECISION_CONST = 2;
export const MAX_PERCENTAGE = 100;